import React, { createContext, useState, useEffect, useCallback } from 'react';
import { obtenerDisponibilidadPublica } from '../api/citaService';

export const CitaContext = createContext();

export const CitaProvider = ({ children }) => {
  const [servicioSeleccionado, setServicioSeleccionado] = useState(null);
  const [datosCliente, setDatosCliente] = useState({
    nombre: '',
    apellido: '',
    email: '',
    telefono: '',
    cedula: ''
  });
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const [horaSeleccionada, setHoraSeleccionada] = useState(null);
  const [metodoPago, setMetodoPago] = useState(null);
  const [datosPago, setDatosPago] = useState({
    numeroTarjeta: '',
    nombreTarjeta: '',
    fechaExpiracion: '',
    cvv: ''
  });
  const [comprobantePago, setComprobantePago] = useState(null);
  const [fechasDisponibles, setFechasDisponibles] = useState([]);
  const [cargandoFechas, setCargandoFechas] = useState(false);
  const [errorFechas, setErrorFechas] = useState(null);
  const [fechasVerificadas, setFechasVerificadas] = useState([]);
  
  // Generar fechas para los próximos 10 días
  const generarProximasFechas = useCallback(() => {
    const fechas = [];
    const hoy = new Date();
    
    for (let i = 1; i <= 10; i++) {
      const fecha = new Date(hoy);
      fecha.setDate(hoy.getDate() + i);
      
      // Inicialmente no tenemos información de horarios, se cargarán bajo demanda
      fechas.push({
        fecha: fecha,
        horarios: [],
        disponible: false, // IMPORTANTE: Asumimos NO disponible hasta verificar con el backend
        cargado: false
      });
    }
    
    return fechas;
  }, []);
  
  // Cargar fechas disponibles al inicio
  useEffect(() => {
    setFechasDisponibles(generarProximasFechas());
  }, [generarProximasFechas]);
  
  // Función para cargar la disponibilidad de una fecha específica
  const cargarDisponibilidadFecha = useCallback(async (doctorId, fecha) => {
    if (!doctorId) return null;
    
    try {
      setCargandoFechas(true);
      setErrorFechas(null);
      
      const fechaFormateada = fecha.toISOString().split('T')[0];
      console.log(`Consultando disponibilidad para: ${fechaFormateada}`);
      
      const respuesta = await obtenerDisponibilidadPublica(doctorId, fechaFormateada);
      const datosDisponibilidad = respuesta.data.data;
      
      console.log(`Respuesta para ${fechaFormateada}:`, datosDisponibilidad);
      
      // Actualizar el estado con los datos del backend
      setFechasDisponibles(prevFechas => {
        return prevFechas.map(item => {
          // Si es la fecha que estamos cargando
          if (item.fecha.toISOString().split('T')[0] === fechaFormateada) {
            return {
              ...item,
              disponible: datosDisponibilidad.disponible,
              horarios: datosDisponibilidad.horarios || [],
              motivo: datosDisponibilidad.motivo,
              cargado: true
            };
          }
          return item;
        });
      });
      
      // Si la fecha está disponible, agregarla a fechas verificadas
      if (datosDisponibilidad.disponible) {
        setFechasVerificadas(prev => {
          // Si ya existe, no agregar duplicado
          if (prev.some(f => f.fecha.toISOString().split('T')[0] === fechaFormateada)) {
            return prev;
          }
          
          return [...prev, {
            fecha,
            disponible: true,
            horarios: datosDisponibilidad.horarios || [],
            cargado: true
          }];
        });
      }
      
      return datosDisponibilidad;
    } catch (error) {
      console.error('Error al cargar disponibilidad:', error);
      setErrorFechas('Error al cargar disponibilidad. Intente nuevamente.');
      return null;
    } finally {
      setCargandoFechas(false);
    }
  }, []);
  
  const resetearFormulario = () => {
    setServicioSeleccionado(null);
    setDatosCliente({
      nombre: '',
      apellido: '',
      email: '',
      telefono: '',
      cedula: ''
    });
    setFechaSeleccionada(null);
    setHoraSeleccionada(null);
    setMetodoPago(null);
    setDatosPago({
      numeroTarjeta: '',
      nombreTarjeta: '',
      fechaExpiracion: '',
      cvv: ''
    });
    setComprobantePago(null);
    setFechasVerificadas([]);
  };
  
  return (
    <CitaContext.Provider
      value={{
        servicioSeleccionado,
        setServicioSeleccionado,
        datosCliente,
        setDatosCliente,
        fechaSeleccionada,
        setFechaSeleccionada,
        horaSeleccionada,
        setHoraSeleccionada,
        metodoPago,
        setMetodoPago,
        datosPago,
        setDatosPago,
        comprobantePago,
        setComprobantePago,
        fechasDisponibles,
        setFechasDisponibles,
        fechasVerificadas,
        cargarDisponibilidadFecha,
        cargandoFechas,
        errorFechas,
        resetearFormulario
      }}
    >
      {children}
    </CitaContext.Provider>
  );
};